import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { lastValueFrom, Observable } from 'rxjs';
import { UserEntity } from '../../models/entities/user-entity';
import { User } from '../../models/home/sign-up';
import { BusinessProcessEntity } from '../../models/settings/business-process-entity';
import { RightsOperationResponse } from '../../models/settings/rights-operation-response';
import { Log, IShortLogger } from '../logger.service';

@Injectable({
    providedIn: 'root'
})
export class BusinessProcessEntityService {
    private readonly logger: IShortLogger<BusinessProcessEntityService> = Log.create(BusinessProcessEntityService);
    public baseUrl = environment.apiUrl;
    constructor(private http: HttpClient) {
    }

    getAllBusinessProcess(): Observable<any> {

        var res = this.http.get(`${this.baseUrl}/v1/users/getbusinessprocess`);
        return res;
    }

    getAllTeams(): Observable<any> {

        var res = this.http.get(`${this.baseUrl}/v1/users/getallteams`);
        return res;
    }


    assignRights(businessProcess: any): Observable<RightsOperationResponse> {
        const headers = { "content-type": "application/json" };

        const body = JSON.stringify(businessProcess);

        this.logger.i("Updating business process with body: ", body);
        this.logger.i("business process: ", businessProcess);
        return this.http.post<RightsOperationResponse>(`${this.baseUrl}/v1/users/assign-rights`, body, { headers });

    }

     revokeRights(businessProcess: any): Observable<RightsOperationResponse> {
        const headers = { "content-type": "application/json" };

        const body = JSON.stringify(businessProcess);

        this.logger.i("Updating business process with body: ", body);
        this.logger.i("business process: ", businessProcess);
        return this.http.post<RightsOperationResponse>(`${this.baseUrl}/v1/users/revoke-rights`, body, { headers });

    }
}
